module.exports = __webpack_public_path__ + "img/polly_the_parrot.cb81be1d.jpg";